import { useState } from "react";
import * as api from "./adminApi";
import { AdminShell, Card, Row, Btn, useAsync } from "./components";

const KIND_LABELS: Record<string, string> = {
  INVITATION: "Invitation",
  COURSE_ASSIGNED: "Course assigned",
  REMINDER: "Reminder",
  COMPLETION: "Completion",
  CERTIFICATE_ISSUED: "Certificate issued",
};

export function NotificationsPage() {
  const { data: failed, error, reload } = useAsync(api.listFailedNotifications, []);
  const [retryingId, setRetryingId] = useState<string | null>(null);

  return (
    <AdminShell crumbs={[{ label: "Admin", to: "/admin" }]} title="Notification issues">
      <p style={{ color: "#666", fontSize: "0.9rem" }}>
        Emails go out from the Learning Hub automatically (invitations, course assignments,
        completions, certificates). Anything that failed to send shows up here — retrying never
        creates a duplicate email, it re-sends the same one.
      </p>
      {error && <Card>{error}</Card>}
      <Card>
        {failed?.length === 0 && <p style={{ color: "#666" }}>No failed notifications.</p>}
        {failed?.map((n) => (
          <Row key={n.id}>
            <span>
              {KIND_LABELS[n.kind] ?? n.kind} → {n.to}
              <br />
              <span style={{ color: "#b00020", fontSize: "0.8rem" }}>{n.error}</span>
            </span>
            <Btn
              kind="ghost"
              disabled={retryingId === n.id}
              onClick={async () => {
                setRetryingId(n.id);
                try {
                  await api.retryNotification(n.id);
                  reload();
                } finally {
                  setRetryingId(null);
                }
              }}
            >
              {retryingId === n.id ? "Retrying…" : "Retry"}
            </Btn>
          </Row>
        ))}
      </Card>
    </AdminShell>
  );
}
